export const prepareFormData = (formValues) => {
  const formData = new FormData();
  Object.entries(formValues).forEach(([key, value]) => {
    // Skip profile_pic and id_proof
    if (key === "pictures") {
      return;
    }
    if (key === "files") {
      if (formValues[key] && formValues[key].length > 0) {
        formValues[key].forEach((i) => {
          formData.append("pictures", i);
        });
      }
    } else if (value !== "" && value !== null && value !== undefined) {
      // Append only non-empty, non-null, and defined values
      formData.append(key, value);
    }
  });
  return formData;
};
